module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/room-2902325cb77637f0735b710815a365ed.svg";